export default "__VITE_ASSET__BpcXLK0S__"